<div class="language-menu" [class.open]="menuOpen()">
  <button
    type="button"
    class="premium-pill-toggle"
    (click)="toggleMenu()"
    [disabled]="switching()"
    [attr.aria-busy]="switching()"
    [attr.aria-expanded]="menuOpen()"
    [attr.aria-label]="translation.instant(languageAriaKey())"
  >
    <div class="toggle-icon">
      <i class="pi pi-globe"></i>
    </div>
    <span class="toggle-label">{{ currentLanguageLabel() }}</span>
    <i class="pi pi-chevron-down menu-chevron" aria-hidden="true"></i>
  </button>

  @if (menuOpen()) {
    <div class="language-options" role="menu">
      @for (language of languages; track language.code) {
        <button
          type="button"
          class="language-option"
          [class.selected]="language.code === currentLanguage()"
          (click)="switchLanguage(language.code)"
          role="menuitem"
        >
          <span>{{ language.label }}</span>
          @if (language.code === currentLanguage()) {
            <i class="pi pi-check" aria-hidden="true"></i>
          }
        </button>
      }
    </div>
  }
</div>
